import React from 'react';
import {Text} from 'react-native';
import styles from './DiscountPercent.style';

export default function DiscountPercent(props) {
  const {value, containerStyle} = props;
  if (Number(value) > 0) {
    return <Text style={[styles.value, containerStyle]}>%{value}</Text>;
  } else {
    return <></>;
  }
}
